import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './auth.module'
import UserService from '@/services/user-service'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth
  },
  state: {
    selectedMainMenu: 'dashboard',
    selectedSubMenu: '',
    isMobile: false,
    landingCode: localStorage.getItem('landingCode')
  },
  mutations: {
    setUserPermitAll(state, auth) {
      state.auth.isUserPermitAll = auth
      localStorage.setItem('isUserPermitAll', auth)
    },
    setLandingCode(state, code) {
      localStorage.setItem('landingCode', code)
      state.landingCode = code
    },
    clearLandingCode(state) {
      localStorage.removeItem('landingCode')
      state.landingCode = null
    }
  },
  actions: {
    getUserInfo() {
      return UserService.getUserInfo()
    }
  }
})
